import { createSlice } from "@reduxjs/toolkit";
const initValue = {
  value: { scTop: 0 },
  mousePos: { x: 0, y: 0 },
};

const scrollTracking = createSlice({
  name: "scrolltracking",
  initialState: initValue,
  reducers: {
    setScroll: (state, action) => {
      state.value = action.payload;
    },
    setMousePos(state, action) {
      state.mousePos = action.payload;
    },
  },
});

const { actions, reducer } = scrollTracking;

export const { setScroll, setMousePos } = actions;

export default reducer;
